import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const InnerWrapper = styled.div`
  max-width: 1440px;
  min-width: 800px;
  margin: 0 auto;
  padding: 0 10px;
`;
